import { QRStatusEntity } from '../entities';
import { authResource } from './Auth';
export const QRStatusResource = authResource({
    path: '/qr/:id/status/:statusId?',
    schema: QRStatusEntity,
    dataExpiryLength: 50
}).extend('get', {
    process: (response) => {
        return { verified: response };
    }
});
